// 搜索文字高亮
export const highlightname = (text, searchText) => {
    if (!searchText || !text) return text;
        
    const lowerText = text.toLowerCase();
    const lowerSearch = searchText.toLowerCase();
    const searchIndex = lowerText.indexOf(lowerSearch);
    
    if (searchIndex === -1) return text;
    
    const beforeMatch = text.substring(0, searchIndex);
    const matchedText = text.substring(searchIndex, searchIndex + searchText.length);
    const afterMatch = text.substring(searchIndex + searchText.length);
    
    return `${beforeMatch}<span style="color:#022DB8">${matchedText}</span>${afterMatch}`;
}
